/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import InputSearch from '@zvuk-b2b/react-uikit/ui/InputSearch';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import Text from '@zvuk-b2b/react-uikit/ui/Text';
import SelectVideoMediafilesList from '../SelectVideoMediafilesList';
import { useVideoMediafiesPresenter } from '../presenters/useVideoMediafiesPresenter';
import { TEXTS } from '../texts';
import { DATA_TEST_IDS } from '../consts';

import styles from './index.module.scss';
import { useSelectVideoMediafilesController } from './useSelectVideoMediafilesController';

const SelectVideoMediafilesModal: React.FC<ModalProps[ModalTypes.SELECT_VIDEO_MEDIAFILES]> = ({
  close,
  openModal,
  prevVideoMediafiles = [],
  emenuMediafiles,
  flow,
  title,
  description,
  videoStreamId,
  refetchSteam,
  isGroupSlave,
}) => {
  const [search, setSearch] = React.useState<string>('');
  const {
    videoMediafiles,
    loading,
    companyId,
    refetch,
    paginationInfo: paginationSettings,
    loadMore,
  } = useVideoMediafiesPresenter(search);

  const {
    onSelectedChange,
    selectedItems,
    onClickUpload,
    getInputProps,
    uploadLoading,
    items,
    nextButtonTitle,
    onRetry,
    onRemoveUpload,
  } = useSelectVideoMediafilesController({
    companyId,
    query: search,
    refetch,
    videoMediafiles,
    loading,
    hasPrevMediafiles: Boolean(prevVideoMediafiles?.length),
  });

  const onClickNext = async () => {
    await close();
    openModal(ModalTypes.CREATE_VIDEO_STREAM, {
      selectedFiles: [...selectedItems, ...prevVideoMediafiles],
      emenuMediafiles,
      openModal,
      flow,
      title,
      description,
      videoStreamId,
      refetch: refetchSteam,
      isGroupSlave,
    });
  };

  return (
    <ModalScreen
      title={TEXTS.CREATE_VIDEO_STREAM_MODAL_TITLE}
      contentClassName={styles.modal}
      titleClassName={styles.fixedSection}
      containerActionButtonsClassName={styles.fixedSection}
      titlePlacement="left"
      onClose={close}
      actionButtons={[
        <Button
          key="button_video_mediafies_next"
          elementId="button_video_mediafies_next"
          type={ButtonType.PRIMARY}
          isDisabled={!selectedItems.length && !prevVideoMediafiles.length}
          isLoading={loading}
          onClick={onClickNext}>
          {nextButtonTitle}
        </Button>,
      ]}>
      <div className={styles.controls}>
        <InputSearch
          containerClassName={styles.SearchInput}
          value={search}
          elementId="search_input_items_list"
          onChange={setSearch}
          placeholder={TEXTS.CREATE_VIDEO_STREAM_INPUT_PLACEHOLDER}
        />

        <input
          data-testid="media_uploader_input"
          style={{ display: 'none' }}
          {...getInputProps()}
        />
        <Button
          key="button_video_mediafies_upload"
          elementId="button_video_mediafies_upload"
          type={ButtonType.SECONDARY}
          isDisabled={loading || uploadLoading}
          onClick={onClickUpload}>
          {TEXTS.CREATE_VIDEO_STREAM_MODAL_BUTTON_UPLOAD}
        </Button>
        <div className={styles.FormatsText}>
          <Text elementId="formats_text">{TEXTS.CREATE_VIDEO_STREAM_FORMATS}</Text>
        </div>
        <div className={styles.SelectFilesText}>
          <Text elementId="select_files_text">{TEXTS.CREATE_VIDEO_STREAM_SELECT_FILES}</Text>
        </div>
      </div>
      <div
        className={styles.listWrapper}
        data-testid={DATA_TEST_IDS.MEDIAFILE_SELECTION_SCROLL}>
        <SelectVideoMediafilesList
          onRetry={onRetry}
          onRemoveUpload={onRemoveUpload}
          itemList={items}
          selectedItems={selectedItems}
          isLoading={loading}
          onChange={onSelectedChange}
          emptySearchText={TEXTS.CREATE_VIDEO_STREAM_EMPTY_FILES}
          paginationSettings={paginationSettings}
          loadMore={loadMore}
        />
      </div>
    </ModalScreen>
  );
};

export default SelectVideoMediafilesModal;
